// Formulario legacy: ModalContacto / Formulario (sin uso en CTAs; ver WhatsAppConsultaContext)
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";

import checkIcon from "../../assets/check-square.png";

const VehicleCard = (vehiculo) => {
  const { openConsultaForm } = useWhatsAppConsulta();

  const handleConsultar = (modelo, version, tipo, tipo_financiacion) => {
    window.dataLayer.push({
      modelo: modelo,
      version: version,
      seccion: tipo,
      event: "consultar",
      tipo_financiacion: tipo_financiacion,
    });
    openConsultaForm();
  };

  const handleCardClick = (modelo, version, tipo, tipo_financiacion) => (e) => {
    if (!window.matchMedia("(max-width: 767px)").matches) return;
    if (e.target.closest(".btn-consultar-card")) return;
    handleConsultar(modelo, version, tipo, tipo_financiacion);
  };

  const tipo = vehiculo.tipo;
  const cardClassName = "card-new-vehicle card-new-vehicle--mobile-clickable h-100 d-flex flex-column justify-content-between";

  return (
    <div className="h-100">
      {vehiculo.info?.convencional?.habilitado && vehiculo.nombreTipo === "convencional" && (
        <section
          className={cardClassName}
          onClick={handleCardClick(
            vehiculo.info.convencional.modelo,
            vehiculo.info.convencional.version,
            tipo,
            vehiculo.info.convencional.titulo_principal,
          )}
        >
          <div className="card-new-vehicle-header">
            <h2 className="titulo-tarjeta"> {vehiculo.info.convencional.modelo} </h2>
            {vehiculo.info.convencional.version !== "" ? (
              <h3 className="titulo-version-tarjeta"> {vehiculo.info.convencional.version} </h3>
            ) : null}
          </div>
          <div className="card-new-vehicle-imagen">
            <img
              src={vehiculo.info.convencional.main_picture}
              alt={vehiculo.info.convencional.modelo}
              className="img-fluid"
            />
          </div>
          <div className="card-new-vehicle-footer">
            {vehiculo.info.convencional?.entrega_inmediata ? (
              <div className="vehicle-footer-entrega-inmediata">
                <p>
                  {" "}
                  <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                </p>
              </div>
            ) : null}

            {vehiculo.info.convencional?.preventa ? (
              <div className="vehicle-footer-entrega-inmediata">
                <p>
                  {" "}
                  <img src={checkIcon} alt="Icon Check" /> PREVENTA EXCLUSIVA
                </p>
              </div>
            ) : null}

            {vehiculo.info.convencional.descripcion_general.length !== "" ? (
              <div className="vehicle-footer-descripcion-general">
                <p>{vehiculo.info.convencional.descripcion_general}</p>
              </div>
            ) : null}

            {vehiculo.info.convencional.subtitulo_principal !== "" ? (
              <div className="vehicle-footer-subtitulo-principal">
                <p>{vehiculo.info.convencional.subtitulo_principal}</p>
              </div>
            ) : null}

            {vehiculo.info.convencional.descripcion_subtitulo_principal !== "" ? (
              <div className="vehicle-footer-descripcion-subtitulo-principal">
                <p>{vehiculo.info.convencional.descripcion_subtitulo_principal}</p>
              </div>
            ) : null}

            <div className="vehicle-footer-titulo-principal">
              {vehiculo.info.convencional.titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-a">{vehiculo.info.convencional.titulo_principal}</p>
              ) : null}

              {vehiculo.info.convencional.descripcion_titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-b">
                  {vehiculo.info.convencional.descripcion_titulo_principal}
                </p>
              ) : null}

              {vehiculo.info.convencional.descripcion_rojo_titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-c">
                  {vehiculo.info.convencional.descripcion_rojo_titulo_principal}
                </p>
              ) : null}
            </div>
          </div>
          <button
            className="btn-consultar-card"
            id={`${vehiculo.info.convencional.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
            onClick={() =>
              handleConsultar(
                vehiculo.info.convencional.modelo,
                vehiculo.info.convencional.version,
                tipo,
                vehiculo.info.convencional.titulo_principal,
              )
            }
          >
            Consultar
          </button>
        </section>
      )}

      {vehiculo.info?.plan?.habilitado && vehiculo.nombreTipo === "plan" && (
        <section
          className={cardClassName}
          onClick={handleCardClick(
            vehiculo.info.plan.modelo,
            vehiculo.info.plan.version,
            tipo,
            vehiculo.info.plan.titulo_principal,
          )}
        >
          <div className="card-new-vehicle-header">
            <h2 className="titulo-tarjeta"> {vehiculo.info.plan.modelo} </h2>
            {vehiculo.info.plan.version !== "" ? (
              <h3 className="titulo-version-tarjeta"> {vehiculo.info.plan.version} </h3>
            ) : null}
          </div>
          <div className="card-new-vehicle-imagen">
            <img src={vehiculo.info.plan.main_picture} alt={vehiculo.info.plan.modelo} className="img-fluid" />
          </div>
          <div className="card-new-vehicle-footer">
            {vehiculo.info.plan.entrega_inmediata ? (
              <div className="vehicle-footer-entrega-inmediata">
                <p>
                  {" "}
                  <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                </p>
              </div>
            ) : null}

            {vehiculo.info.plan.tipos_planes[0].nombre_plan !== "" ? (
              <div className="vehicle-footer-planes-cuotas">
                {vehiculo.info.plan.tipos_planes.map((plan, index) => {
                  return (
                    <div key={index} className="vehicle-footer-planes-cuotas-card">
                      <div className="vehicle-footer-planes-cuotas-card-header">
                        <p className="cuotas-card-header-titulo">{plan.nombre_plan}</p>
                        <div className="cuotas-card-header-cuotas-desde">
                          <p className="cuotas-card-header-cuotas-desde-precio">{plan.precio}</p>
                        </div>
                      </div>
                      <div className="vehicle-footer-planes-cuotas-card-footer">
                        <p>{plan.descripcion}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : null}

            {vehiculo.info.plan.descripcion_general.length !== "" ? (
              <div className="vehicle-footer-descripcion-general">
                <p>{vehiculo.info.plan.descripcion_general}</p>
              </div>
            ) : null}

            {vehiculo.info.plan.subtitulo_principal !== "" ? (
              <div className="vehicle-footer-subtitulo-principal">
                <p>{vehiculo.info.plan.subtitulo_principal}</p>
              </div>
            ) : null}

            {vehiculo.info.plan.descripcion_subtitulo_principal !== "" ? (
              <div className="vehicle-footer-descripcion-subtitulo-principal">
                <p>{vehiculo.info.plan.descripcion_subtitulo_principal}</p>
              </div>
            ) : null}

            {vehiculo.info.plan.cuota_desde !== "" ? (
              <div className="vehicle-footer-cuota-desde">
                <p className="segundo-parrafo">{vehiculo.info.plan.cuota_desde}</p>
              </div>
            ) : null}

            <div className="vehicle-footer-titulo-principal">
              {vehiculo.info.plan.titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-a">{vehiculo.info.plan.titulo_principal}</p>
              ) : null}

              {vehiculo.info.plan.descripcion_titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-b">{vehiculo.info.plan.descripcion_titulo_principal}</p>
              ) : null}

              {vehiculo.info.plan.descripcion_rojo_titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-c">
                  {vehiculo.info.plan.descripcion_rojo_titulo_principal}
                </p>
              ) : null}
            </div>
          </div>

          <button
            className="btn-consultar-card"
            id={`${vehiculo.info.plan.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
            onClick={() =>
              handleConsultar(
                vehiculo.info.plan.modelo,
                vehiculo.info.plan.version,
                tipo,
                vehiculo.info.plan.titulo_principal,
              )
            }
          >
            Consultar
          </button>
        </section>
      )}

      {vehiculo.info?.adjudicado?.habilitado && vehiculo.nombreTipo === "adjudicado" && (
        <section
          className={cardClassName}
          onClick={handleCardClick(
            vehiculo.info.adjudicado.modelo,
            vehiculo.info.adjudicado.version,
            tipo,
            vehiculo.info.adjudicado.titulo_principal,
          )}
        >
          <div className="card-new-vehicle-header">
            <h2 className="titulo-tarjeta"> {vehiculo.info.adjudicado?.modelo} </h2>
            {vehiculo.info.adjudicado?.version !== "" ? (
              <h3 className="titulo-version-tarjeta"> {vehiculo.info.adjudicado?.version} </h3>
            ) : null}
          </div>
          <div className="card-new-vehicle-imagen">
            <img
              src={vehiculo.info.adjudicado?.main_picture}
              alt={vehiculo.info.adjudicado?.modelo}
              className="img-fluid"
            />
          </div>
          <div className="card-new-vehicle-footer">
            {vehiculo.info.adjudicado?.entrega_inmediata ? (
              <div className="vehicle-footer-entrega-inmediata">
                <p>
                  {" "}
                  <img src={checkIcon} alt="Icon Check" /> ENTREGA INMEDIATA
                </p>
              </div>
            ) : null}

            {vehiculo.info.adjudicado?.descripcion_general.length !== "" ? (
              <div className="vehicle-footer-descripcion-general">
                <p>{vehiculo.info.adjudicado?.descripcion_general}</p>
              </div>
            ) : null}

            {vehiculo.info.adjudicado?.subtitulo_principal !== "" ? (
              <div className="vehicle-footer-subtitulo-principal">
                <p>{vehiculo.info.adjudicado?.subtitulo_principal}</p>
              </div>
            ) : null}

            {vehiculo.info.adjudicado?.descripcion_subtitulo_principal !== "" ? (
              <div className="vehicle-footer-descripcion-subtitulo-principal">
                <p>{vehiculo.info.adjudicado?.descripcion_subtitulo_principal}</p>
              </div>
            ) : null}

            <div className="vehicle-footer-titulo-principal">
              {vehiculo.info.adjudicado?.titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-a">{vehiculo.info.adjudicado?.titulo_principal}</p>
              ) : null}

              {vehiculo.info.adjudicado?.descripcion_titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-b">
                  {vehiculo.info.adjudicado?.descripcion_titulo_principal}
                </p>
              ) : null}

              {vehiculo.info.adjudicado?.descripcion_rojo_titulo_principal !== "" ? (
                <p className="vehicle-footer-titulo-principal-c">
                  {vehiculo.info.adjudicado?.descripcion_rojo_titulo_principal}
                </p>
              ) : null}
            </div>
          </div>
          <button
            className="btn-consultar-card"
            id={`${vehiculo.info.adjudicado?.modelo.replace(/\s+/g, "-").toLowerCase()}-${tipo}`}
            onClick={() =>
              handleConsultar(
                vehiculo.info.adjudicado.modelo,
                vehiculo.info.adjudicado.version,
                tipo,
                vehiculo.info.adjudicado.titulo_principal,
              )
            }
          >
            Consultar
          </button>
        </section>
      )}
    </div>
  );
};

export default VehicleCard;
